import { withTheme } from 'emotion-theming'
import styled from '@emotion/styled'
import PropTypes from 'prop-types'
import { withTranslation } from 'server/i18n'

import style from './BoatStatement.style'

const BoatStatementStyled = styled.div(props => ({ ...style(props) }))

const BoatStatement = ({ t }) => {
    return (
        <BoatStatementStyled>
            <p className="statement">{t('good-faith-statement')}</p>
        </BoatStatementStyled>
    )
}

BoatStatement.propTypes = {
    t: PropTypes.func.isRequired
}

export default withTranslation('common')(withTheme(BoatStatement))
